export default "__VITE_ASSET__CF55dsf1__"